import Vue from 'ninenine-white-label/Vue'
import Vuex from 'vuex'

import opportunities from 'ninenine-white-label/store/modules/opportunities'
import location from 'ninenine-white-label/store/modules/location'
import user from 'ninenine-white-label/store/modules/user'
import domains from 'ninenine-white-label/store/modules/domains'
import graphql_queries from 'ninenine-white-label/store/modules/graphql_queries'
import tests from 'ninenine-white-label/store/modules/tests'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    opportunities,
    location,
    user,
    domains,
    graphql_queries,
    tests
  },

  state: {
    source: 'carreiras',
    companyId: process.env.VUE_APP_COMPANY_ID,

    bancoDeTalentos: process.env.VUE_APP_BANCO_DE_TALENTOS,

    tkn: `Token token=${process.env.VUE_APP_API_TOKEN}`,

    deviseForm: null,
    deviseLoading: false,

    deviseTrying: { },

    deviseClosedToReadTerms: { },
    pendingAcceptTerms: false,

    personalDataForm: { },
    educationsForms: [],
    professionalExperiencesForms: [],
    languagesForms: [],
    flag_no_professional_experience: false,
    opportunityQuestionsForm: { },
    indicationForm: { },

    companyName: 'Bluefit',

    websiteName: 'Bluefit Carreiras',

    areas: [
      {
        "id": 3455,
        "name": "Compras",
      },
      {
        "id": 3464,
        "name": "Engenharia",
      },
      {
        "id": 3454,
        "name": "Finanças",
      },
      {
        "id": 3465,
        "name": "Fiscal e Tributária",
      },
      {
        "id": 3457,
        "name": "Logística",
      },
      {
        "id": 3493,
        "name": "Manutenção",
      },
      {
        "id": 3452,
        "name": "Marketing",
      },
      {
        "id": 3492,
        "name": "Operações",
      },
      {
        "id": 3466,
        "name": "Produção e Fabricação",
      },
      {
        "id": 3456,
        "name": "Qualidade",
      },
      {
        "id": 3453,
        "name": "Recursos Humanos",
      },
      {
        "id": 3459,
        "name": "Serviços Gerais",
      },
      {
        "id": 3467,
        "name": "Suprimentos (Compras)",
      },
      {
        "id": 3468,
        "name": "Tecnologia",
      },
    ],

    teams: [
      {
        "title": "Escritório",
        "slug": "escritorio",
        "coverImage": "banner-escritorio.jpg"
      },
      {
        "title": "Fábrica",
        "slug": "fabrica",
        "coverImage": "banner-fabrica.jpg"
      },
      {
        "title": "Lojas",
        "slug": "lojas",
        "coverImage": "banner-lojas.jpg"
      },
    ],

    faq: {
      "slug": "faq",
      "title": "Faq",
      "faqItems": [
        {
          "title": "Como posso me candidatar a uma vaga na Bluefit?",
          "content": `<p>É simples! Basta acessar a nossa página de carreiras na plataforma da 99jobs, encontrar a vaga que mais combina com você e clicar em "Quero me inscrever". Preencha o formulário com seus dados e, se o seu perfil for compatível com a vaga, entraremos em contato para as próximas etapas do processo seletivo.</p>`,
        },
        {
          "title": "Não encontrei nenhuma vaga com o meu perfil. Posso deixar meu currículo?",
          "content": `<p>Claro! Que tal fazer isso agora? Clique aqui e se cadastre em nosso Banco de Talentos.</p>`,
        },
        {
          "title": "Existe alguma taxa de inscrição?",
          "content": `<p>Não cobramos nenhuma taxa de inscrição para participar do processo seletivo de vagas na Bluefit Academias.</p>`,
        },
        {
          "title": "Onde ficam as academias Bluefit?",
          "content": `<p>Temos mais de 140 academias espalhadas pelo Brasil, presentes em 19 estados.</p>
          <p><a href="https://www.bluefit.com.br/unidades?utm_source=google&utm_medium=cpc&utm_campaign=search_fundo&utm_content=setembro&utm_medium=google&landing_page=musculacao&gad_source=1&gclid=CjwKCAjw6c63BhAiEiwAF0EH1P30Tq8uI9_CRTEdGMwjWy2mqYdzXOqy9uyOSmgIpvO6UfhTuU2GpxoCligQAvD_BwE" target="_blank">Clique aqui e confira os endereços.</a></p>`,
        },
        {
          "title": "Onde ficam os escritórios Bluefit?",
          "content": `<p>Temos escritórios em São Paulo-SP.</p>`,
        },
        {
          "title": "Qual o modelo de trabalho?",
          "content": `<p>Para as vagas na academia, o trabalho é presencial. Para vagas no escritório, temos a modalidade presencial e híbrido (home office e presencial).</p>`,
        },
        {
          "title": "Quais são as áreas de atuação na Bluefit?",
          "content": `<p>Aqui você encontra oportunidades em diversas áreas, como: Operações (recepção, atendimento ao cliente, gestão de unidades, etc.); Professores (aulas coletivas, musculação, personal training, etc); Comercial (vendas, marketing, atendimento, etc.); Administrativo (financeiro, RH, jurídico, tecnologia, etc.); Estágios (diversas áreas para estudantes colocarem seus conhecimentos em prática.)</p>`,
        },
        {
          "title": "Qual é a cultura da Bluefit?",
          "content": `<p>Nossa cultura é movida pela paixão em democratizar a saúde, e por isso nossa busca é por resultados e inovação. Valorizamos o intraempreendedorismo, a paixão por gente, a vontade de evoluir e o tratamento igualitário, acreditando que cada pessoa do time Bluefit é fundamental para alcançarmos nossa missão de tornar a saúde algo possível para todos. Por aqui, você vai encontrar um ambiente de trabalho alegre, proativo e diverso, onde cada um tem a oportunidade de contribuir.</p>`,
        },
        {
          "title": "A Bluefit oferece flexibilidade de horários?",
          "content": `<p>Buscamos oferecer flexibilidade sempre que possível, de acordo com a necessidade da área e da função. Algumas vagas podem ter horários mais flexíveis do que outras, e isso será informado na descrição da vaga.</p>`,
        },
        {
          "title": "Quais são as perspectivas de futuro da Bluefit?",
          "content": `<p>A Bluefit está em constante expansão e busca se consolidar como a maior rede de academias da América Latina. Temos planos de crescimento, inovação e expansão para os próximos anos e, ao se juntar à Bluefit, você fará parte de uma empresa com um futuro promissor e uma missão: democratizar a saúde para todos.</p>`,
        },
      ]
    }
  },


  getters: {
    basicProfileEmpty: state => {
      const profile = state.user.profile;

      return (
        !profile.nationality || profile.nationality.length == 0 ||
        (
          (!profile.cpf || profile.cpf.length == 0) &&
          (!profile.passport || profile.passport.length == 0)
        ) ||
        !profile.phone || profile.phone.length == 0 ||
        !profile.birthday || profile.birthday.length == 0 ||
        !profile.gender || profile.gender.length == 0 ||
        !profile.raceAndEthnicity || profile.raceAndEthnicity.length == 0 ||
        !profile.pronoun || profile.pronoun.length == 0 ||
        !profile.personalIncome || profile.personalIncome.length == 0 ||
        !profile.location.zipcode || profile.location.zipcode.length == 0 ||
        !profile.location.street || profile.location.street.length == 0 ||
        !profile.location.number || profile.location.number.length == 0 ||
        !profile.location.neighborhood || profile.location.neighborhood.length == 0 ||
        !profile.location.city || profile.location.city.length == 0 ||
        !profile.location.stateId || profile.location.stateId.toString().length == 0
      ) &&
        (!profile.educations || profile.educations.length == 0) &&
        (!profile.professionalExperiences || profile.professionalExperiences.length == 0 || state.flag_no_professional_experience == false)
    }
  },


  mutations: {
    CHANGE_TKN(state, payload){
      state.tkn = payload;
    },

    DEVISE_FORM(state, payload) {
      state.deviseForm = payload;
    },

    DEVISE_LOADING(state, payload) {
      state.deviseLoading = payload;
    },

    DEVISE_TRYING(state, payload) {
      state.deviseTrying = payload == null ? { } : payload;
    },

    DEVISE_DEVISE_CLOSED_TO_READ_TERMS(state, payload) {
      state.deviseClosedToReadTerms = payload == null ? { } : payload;
    },

    SET_PENDING_ACCEPT_TERMS(state, payload) {
      state.pendingAcceptTerms = payload;
    },

    PERSONAL_DATA_FORM(state, payload) {
      state.personalDataForm = payload;
    },

    EDUCATIONS_FORMS(state, payload) {
      if (!payload) {
        state.educationsForms = []
      } else {
        if (state.educationsForms.find(form => form._uid == payload._uid)) {
          state.educationsForms[state.educationsForms.findIndex(form => form._uid == payload._uid)] = payload;
        } else {
          state.educationsForms.push(payload);
        }
      }
    },

    PROFESSIONAL_EXPERIENCES_FORMS(state, payload) {
      if (!payload) {
        state.professionalExperiencesForms = []
      } else {
        if (state.professionalExperiencesForms.find(form => form._uid == payload._uid)) {
          state.professionalExperiencesForms[state.professionalExperiencesForms.findIndex(form => form._uid == payload._uid)] = payload;
        } else {
          state.professionalExperiencesForms.push(payload);
        }
      }
    },

    LANGUAGES_FORMS(state, payload) {
      if (!payload) {
        state.languagesForms = []
      } else {
        if (state.languagesForms.find(form => form._uid == payload._uid)) {
          state.languagesForms[state.languagesForms.findIndex(form => form._uid == payload._uid)] = payload;
        } else {
          state.languagesForms.push(payload);
        }
      }
    },

    SET_FLAG_PROFESSIONAL_EXPERIENCE(state, payload) {
      state.flag_no_professional_experience = payload
    },

    OPPORTUNITY_QUESTIONS_FORM(state, payload) {
      state.opportunityQuestionsForm = payload
      localStorage.setItem('opportunity_questions', JSON.stringify(payload))
    },

    INDICATION_FORM(state, payload) {
      state.indicationForm = payload
      localStorage.setItem('indication_form', JSON.stringify(payload))
    }
  },

  actions: {
  }
})
